import { getRegion, Region } from './utils';

export interface RegionalConfig {
  isEsignEnabled: boolean;
  showRegionalCourtPicker: boolean;
  isResourceCenterRegion: boolean;
}

export const REGIONAL_CONFIG: Record<Region, RegionalConfig> = {
  [Region.US]: {
    isEsignEnabled: true,
    showRegionalCourtPicker: false,
    isResourceCenterRegion: true,
  },
  [Region.EU]: {
    isEsignEnabled: false,
    showRegionalCourtPicker: true,
    isResourceCenterRegion: true,
  },
  [Region.AU]: {
    isEsignEnabled: false,
    showRegionalCourtPicker: true,
    isResourceCenterRegion: true,
  },
  [Region.CA]: {
    isEsignEnabled: false,
    showRegionalCourtPicker: true,
    isResourceCenterRegion: false,
  },
};

export const getRegionalConfig = (): RegionalConfig => {
  const region = getRegion();
  return REGIONAL_CONFIG[region];
};
